import dynamic from "next/dynamic";
import { useFastBuy } from "@/domain/ProductItem/index";

import type { FastBuyProps } from "./fastBuy.types";

const FastBuyButton = dynamic(() => import("./FastBuyButton"), { ssr: false });

import s from "./fastBuy.module.scss";

const FastBuy = ({
  isProductAvailable,
  selectedSku,
  fullWidth,
  hideIcon,
  label,
  buttonVariant,
  buttonIcon,
  buttonClassName,
  inline
}: FastBuyProps) => {
  const { counter, firstClick, setCounter, setLoading, setFirstClick } =
    useFastBuy();

  return (
    <div
      className={`${s.wrapper} ${inline ? s["wrapper-inline"] : ""} fastbuy_wrapper`}
    >
      <FastBuyButton
        counter={counter}
        selectedSku={selectedSku}
        isProductAvailable={isProductAvailable}
        firstClick={firstClick}
        fullWidth={fullWidth}
        hideIcon={hideIcon}
        label={label}
        buttonVariant={buttonVariant}
        buttonIcon={buttonIcon}
        buttonClassName={buttonClassName}
        setLoading={setLoading}
        setCounter={setCounter}
        setFirstClick={setFirstClick}
      />
    </div>
  );
};
export default FastBuy;
